import {AccountStateLogComponent} from './account.state-log.component';

export const ACCOUNT_STATE_LOG_COMPONENTS = [
    AccountStateLogComponent
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/account-state-log/index.ts